var h = `

<div style="text-align: center; margin-top: 25px;">Shopping for something special? Let us help!</div>
<div id="gift-select">
  <span class="gift-finder-span">
    <select class="gift-finder-select" id="age" onchange="setSelectValue(this)">
		<option value="default" selected>Age</option>
		<option value="Toddlers">Toddlers</option>
		<option value="Preschool">Preschool</option>
		<option value="Ages 5-8">Ages 5-8</option>
		<option value="Ages 9-12">Ages 9-12</option>
		<option value="Teens">Teens</option>
		<option value="Adults">Adults</option>
    </select>
  </span>

  <span class="gift-finder-span">
    <select class="gift-finder-select" id="category" onchange="setSelectValue(this)">
      <option value="default" selected>Category</option>
      <option value="3D Puzzles">3D Puzzles</option>
      <option value="Adult Party Games">Adult Party Games</option>
      <option value="Arts & Crafts">Arts & Crafts</option>
      <option value="Bouncers & Riding Toys">Bouncers & Riding Toys</option>
      <option value="Brain Teaser Puzzles">Brain Teaser Puzzles</option>
      <option value="Building & Construction">Building & Construction</option>
      <option value="Card Games">Card Games</option>
      <option value="Classic Games">Classic Games</option>
      <option value="Early Learning & Development">Early Learning & Development</option>
      <option value="Educational Toys & Games">Educational Toys & Games</option>
      <option value="Electronic Games">Electronic Games</option>
      <option value="Family Games">Family Games</option>
      <option value="Floor Puzzles">Floor Puzzles</option>
      <option value="Foam & Dart Blasters">Foam & Dart Blasters</option>
      <option value="Game Supplies">Game Supplies</option>
      <option value="Gift Card">Gift Card</option> 
      <option value="Glow-In-The-Dark">Glow-In-The-Dark</option>
      <option value="Jigsaws (10-499 pcs)">Jigsaws (10-499 pcs)</option>
      <option value="Jigsaws (500-750 pcs)">Jigsaws (500-750 pcs)</option>
      <option value="Jigsaws (751-Up pcs)">Jigsaws (751-Up pcs)</option>
      <option value="Kids Games">Kids Games</option>
      <option value="Magic">Magic</option>
      <option value="Musical Toys">Musical Toys</option>
      <option value="Marble Runs & Sets">Marble Runs & Sets</option>
      <option value="Outdoor & Active Play">Outdoor & Active Play</option>
      <option value="Preschool Games">Preschool Games</option>
      <option value="Pretend Play">Pretend Play</option>
      <option value="Sand & Moldable Toys">Sand & Moldable Toys</option>
      <option value="Science & Discover">Science & Discovery</option>
      <option value="Skill & Action Games">Skill & Action Games</option>
      <option value="Strategy Games">Strategy Games</option>
      <option value="Travel Games">Travel Games</option>
      <option value="Word Games">Word Games</option>
    </select>
  </span>

</div>
  <div style="text-align: center; margin-top: 25px;">Price</div>
  <div style="width: 52vw; margin-left: auto; margin-right: auto;"><span type="text" class="giftSlider" id="GiftSlider"></span></div>
  <div style="text-align:center"><input type="button" class="btn giftfinder" value="Show Gift Ideas" onclick="formatURLString()"></input></div>
  <div id="gift-finder"></div>

`;

var giftSlider;
var sliderValues;

var giftValues = {
  age: {p: 'uff_y9soir_tags', v: null},
  type: {p: 'uff_qf9081_productType', v: null},
  category: {p: 'uff_qf9081_productType', v: null},
  price: {p: 'uff_n9ijcf_price', v: null}
}




  




$( document ).ready(function() {  //   setTimeout(function(){
	$("ul.nav.site-nav div#gift-finder").closest("div.site-nav__dropdown").removeClass('small-dropdown').addClass('mega-dropdown').css('min-height', 300).html(h);
  	$("ul.nav.site-nav div#gift-finder").closest("li.site-nav__item").first().mouseover(function(){ setupGiftSlider(); })//   }, 1000);
//     $("ul.nav.site-nav div#gift-finder").closest("div.mega-dropdown").first().mouseout(function(){ giftSlider = null; $(".rs-container").remove() })
});

function setupGiftSlider(){
  if (giftSlider && $("ul.nav.site-nav .rs-scale span").length > 0 && $("ul.nav.site-nav .rs-scale span").first().css('width') == '0px'){
  	giftSlider = false; 
    if ($(".rs-container").length > 0)
    	$(".rs-container").remove();
  }
  
  if (!giftSlider) {
    giftSlider = true;
    setTimeout(function(){
    giftSlider = new rSlider({
      target: '#GiftSlider',
      values: [0,5,10,15,20,25,30,35],
      step: 5,
      range: true,
      scale: true,
      tooltip: false,
      onChange: function(){
        sliderValues = giftSlider.getValue();
        var values = sliderValues.split(",");
        if(values[1] == 35)
        {
          values[1] = 1000;
          //console.log("Setting Max");
        }
        giftValues.price.v = ":" + values[0] + " :" + values[1]
      }
  	});
    },25);
    
    if (sliderValues && giftSlider) giftSlider.setValues(sliderValues);
  }
}


function setSelectValue(evt){
  	giftValues[evt.id].v = encodeURIComponent(evt.value);
}

function formatURLString(){
  var keys = Object.keys(giftValues);
  var urlParam;
  for (var i = 0; i < keys.length; i++){
    
    var key = keys[i];
    console.log('key', key, giftValues[key]);
    var giftValue = giftValues[key];
    if (giftValue.v) {
      if (!urlParam) {
       	urlParam = "?" + giftValue.p + "=" + giftValue.v;
      } else {
       	urlParam += "&" + giftValue.p + "=" + giftValue.v;
      }
    }
  }
  
  var compositeUrlParam = "/collections/gift-finder" + urlParam;
  ga('send', 'event', 'Gift Finder', 'Submit', compositeUrlParam);
  console.log('urlParam', urlParam);
  window.location.href = "/collections/gift-finder" + urlParam;
}


var toDelete = `  <span class="gift-finder-span">
    <select class="gift-finder-select" id="gift-type">
      <option value="default" selected>Gift Type</option>
      <option value="All">All</option>
      <option value="Games">Games</option>
      <option value="Puzzles">Puzzles</option>
      <option value="Education and Learning">Education & Learning</option>
      <option value="Active Play">Active Play</option>
      <option value="AreYouGame Collection">AreYouGame Collection</option>
    </select>
  </span>
`;